import clsx from 'clsx';
import React from 'react';
import { twMerge } from 'tailwind-merge';

export const Skeleton = ({ className, children }: { className?: string; children: React.ReactNode }) => (
  <div className={clsx(`overflow-hidden rounded-2xl shadow-2xl`, className)}>
    <div className='h-full w-full'>{children}</div>
  </div>
);

export const SkeletonRow = ({ className }: { className?: string }) => (
  <div className={twMerge(clsx('h-full animate-pulse rounded-sm bg-gray-200', className))} />
);
